module.exports = __webpack_public_path__ + "static/img/banner.1242aa2a.png";